import { useEffect, useState } from 'react';
import JunoButton from '../common/JunoButton';
import DataTable from '../DataTable';
import { useSelector } from 'react-redux';
import { apiService } from '../../../client/common/apiCallService';
import CustomSwitch from '../common/CustomSwitch';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import JunoModal from '../common/JunoModal';
import AddUsersAccounts from './AddUsersAccounts';
import { CircularProgress, Menu, MenuItem } from '@mui/material';
import { testEmailRule, useJunoCommonFunctions } from '../../../client/Juno/helpers';
import ActionConfirmModal from '../common/ActionConfirmModal';
import MobileAdditionalAccounts from './MobileAdditionalAccounts';

const overviewTableConfig = {
    columns: [
        {
            key: 'clientEmail',
            label: 'Account email',
        },
        { key: 'readOnly', label: 'read only' },
    ],
};

const AdditionalAccounts = ({ modalFlag = false, setModalFlag = () => {} }) => {
    const [loading, setLoading] = useState(false);
    const clientData = useSelector(state => state.juno.clientData);
    const apiUrl = useSelector(state => state.config.api_url);
    const [clientUsersList, setClientUsersList] = useState([]);
    const [modals, setModals] = useState({
        openAddNewModal: false,
    });

    useEffect(() => {
        if (modalFlag) {
            setModals({ openAddNewModal: true });
        } else {
            setModals({ openAddNewModal: false });
        }
    }, [modalFlag]);

    const [selectedAccount, setSelectedAccount] = useState();
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();
    const getClientUsers = async () => {
        if (clientData) {
            setLoading(true);
            apiService(
                (window.location.hostname === 'localhost' ? apiUrl : '') +
                    '/restapi/get-client-associated-user',
                {
                },
                async data => {
                    if (data) {
                        setClientUsersList(data.clientsData);
                        setLoading(false);
                    }
                },
                err => {
                    console.log(err);
                    setLoading(false);
                },
            );
        }
    };

    const handleUpdateUser = async (userData, type) => {
        let payload = {
            parentClient: clientData._id,
            type,
        };

        if (type === 'update' || type === 'updateForm') {
            payload = {
                ...payload,
                updateEmail: userData.updateEmail,
                clientEmail: userData.clientEmail,
                password: userData.password,
                readOnly: userData.readOnly,
            };
        } else {
            payload = {
                ...payload,
                clientEmail: userData.clientEmail,
            };
        }

        if (clientData) {
            apiService(
                (window.location.hostname === 'localhost' ? apiUrl : '') +
                    '/restapi/update-client-associated-user',
                {
                    ...payload,
                },
                async () => {
                    getClientUsers();
                    onModalClose();
                },
                err => {
                    console.log(err);
                    onModalClose();
                },
            );
        }
    };

    const customRender = (row, data) => {
        if (row.key == 'readOnly') {
            const handleMenuClose = () => setModals({ [data?._id]: false });
            return (
                <div className="flex w-full justify-between">
                    <CustomSwitch
                        checked={data.readOnly}
                        onClick={() =>
                            handleUpdateUser(
                                {
                                    updateEmail: data.clientEmail,
                                    readOnly: !data.readOnly,
                                },
                                'update',
                            )
                        }
                    />
                    <MoreVertIcon
                        data-e2e={data.clientEmail}
                        className="text-profile-text-muted"
                        onClick={event => setModals({ [data?._id]: event.target })}
                    />
                    <Menu
                        anchorEl={modals[data?._id]}
                        open={Boolean(modals[data?._id])}
                        onClose={handleMenuClose}
                        slotProps={{
                            paper: {
                                sx: {
                                    backgroundColor: 'var(--common-modal-bg)',
                                    borderRadius: '8px',
                                    padding: '4px',
                                    minWidth: '160px',
                                },
                            },
                        }}>
                        {['edit', 'delete'].map(item => (
                            <MenuItem
                                data-e2e={item}
                                className="capitalize"
                                key={item}
                                onClick={() => {
                                    handleMenuClose();
                                    setSelectedAccount({ data, action: item });
                                }}
                                sx={{
                                    color: 'var(--color-text)',
                                    '&:hover': {
                                        backgroundColor: 'var(--card-bg)',
                                    },
                                }}>
                                {item}
                            </MenuItem>
                        ))}
                    </Menu>
                </div>
            );
        }
    };

    const onModalClose = () => {
        if (modals?.openAddNewModal) {
            setModals({ openAddNewModal: false });
            setModalFlag(false);
        }

        if (selectedAccount?.action) {
            setSelectedAccount(null);
        }
    };

    useEffect(() => {
        getClientUsers();
    }, []);

    const isEdit = selectedAccount?.action == 'edit';

    return (
        <>
            {windowWidth > 1100 ? (
                <div className="self-stretch px-6 py-4">
                    <div className="self-stretch inline-flex justify-between items-center gap-3 w-full">
                        <div className="flex-1 flex justify-start items-center gap-1 grow-1">
                            <h2 className="justify-start text-profile-primary text-sm font-semibold leading-tight uppercase">
                                additonal accounts
                            </h2>
                        </div>
                        <JunoButton
                            dataE2e="add-new-btn"
                            className={'!w-auto !px-2 !py-1.5 !h-auto font-semibold text-xs'}
                            onClick={() => setModals({ openAddNewModal: true })}>
                            add new
                        </JunoButton>
                    </div>
                </div>
            ) : null}
            <DataTable
                className="!rounded-none !overflow-scroll hide-scrollbar hidden lg:block"
                tdClassName="w-1/5 !lowercase !font-medium !leading-tight !text-sm"
                trClassName="!bg-modal-bg"
                tbodyClassName="!divide-secondary"
                data={clientUsersList}
                columns={overviewTableConfig.columns}
                hasNestedRows={false}
                customRenderCell={customRender}
                // loading={loading}
            />

            <div className="block lg:hidden">
                {loading ? (
                    <div className="bg-text absolute top-0 w-full h-full opacity-25 z-1500 flex justify-center">
                        <CircularProgress className="m-auto" size={50} />
                    </div>
                ) : (
                    <MobileAdditionalAccounts
                        data={clientUsersList}
                        loading={loading}
                        handleUpdateUser={handleUpdateUser}
                        isEdit={isEdit}
                        setSelectedAccount={setSelectedAccount}
                    />
                )}
            </div>

            {modals.openAddNewModal || isEdit ? (
                <JunoModal
                    title={`${isEdit ? 'edit' : 'add'} aditional account`}
                    open={modals.openAddNewModal || isEdit}
                    onClose={onModalClose}
                    fullScreenMobile={true}
                    content={() => (
                        <AddUsersAccounts
                            onClose={onModalClose}
                            getClientUsers={getClientUsers}
                            account={selectedAccount?.data}
                            handleUpdateUser={handleUpdateUser}
                            isEdit={isEdit}
                        />
                    )}
                />
            ) : null}
            {selectedAccount?.action == 'delete' ? (
                <ActionConfirmModal
                    open={true}
                    heading="delete additional account"
                    subHeading="are you sure you want to delete the additional account?"
                    body={() => (
                        <span className="!text-text text-base font-semibold uppercase leading-normal uppercase">
                            {selectedAccount?.data?.clientEmail}
                        </span>
                    )}
                    onCancel={() => setSelectedAccount(null)}
                    type={'delete'}
                    actionButtonText={'delete'}
                    onConfirm={() => {
                        handleUpdateUser(
                            { clientEmail: selectedAccount?.data?.clientEmail },
                            'delete',
                        );
                    }}
                />
            ) : null}
        </>
    );
};

export default AdditionalAccounts;
